function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { IntegerColumnFormatter } from '@deephaven/jsapi-utils';
import FormatContextMenuUtils from "./FormatContextMenuUtils.js";
class IntegerFormatContextMenu {
  /**
   * Creates list of formatting options for Integer context menu
   * @param dh JSAPI instance
   * @param selectedFormat Selected format object, null for no selected format
   * @param onCustomFormatChange Callback to call when the custom format is changed
   * @returns Array of formatting options for the context menu
   */
  static getOptions(dh, selectedFormat, onCustomFormatChange) {
    var formatItems = [{
      format: IntegerColumnFormatter.FORMAT_THOUSANDS,
      group: IntegerFormatContextMenu.presetGroup
    }, {
      format: IntegerColumnFormatter.FORMAT_MILLIONS,
      group: IntegerFormatContextMenu.presetGroup
    }, {
      format: IntegerColumnFormatter.FORMAT_SCIENTIFIC_NOTATION,
      group: IntegerFormatContextMenu.presetGroup
    }];
    var defaultFormatOption = FormatContextMenuUtils.makeOption('Default', null, IntegerFormatContextMenu.defaultGroup, FormatContextMenuUtils.isDefaultSelected(selectedFormat));
    var presetFormatOptions = formatItems.map(item => FormatContextMenuUtils.makeOption(item.format.label, item.format, item.group, IntegerColumnFormatter.isSameFormat(item.format, selectedFormat)));
    var isCustomSelected = FormatContextMenuUtils.isCustomSelected(selectedFormat);
    var customFormat = isCustomSelected ? selectedFormat : IntegerColumnFormatter.makeCustomFormat();
    var customFormatOption = FormatContextMenuUtils.makeCustomFormatOption(customFormat, IntegerFormatContextMenu.customGroup, IntegerColumnFormatter.DEFAULT_FORMAT_STRING, isCustomSelected, formatString => {
      if (formatString != null) {
        var newCustomFormat = IntegerColumnFormatter.makeCustomFormat(formatString);
        if (IntegerColumnFormatter.isValid(dh, newCustomFormat)) {
          onCustomFormatChange(newCustomFormat);
        }
      } else {
        onCustomFormatChange(null);
      }
    });
    return [defaultFormatOption, ...presetFormatOptions, customFormatOption];
  }
}
_defineProperty(IntegerFormatContextMenu, "defaultGroup", 10);
_defineProperty(IntegerFormatContextMenu, "presetGroup", 20);
_defineProperty(IntegerFormatContextMenu, "customGroup", 30);
export default IntegerFormatContextMenu;
//# sourceMappingURL=IntegerFormatContextMenu.js.map